module.exports = "<div class=\"centered\">\r\n<h4>Something was wrong! Please contact the adminstrator</h4>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/opc/opc-app/error/error.component.html
// module id = ./src/opc/opc-app/error/error.component.html
// module chunks = main